import { Field, Form, FormSpy } from 'react-final-form';
import styles from './InvestmentRevamp.module.scss';
import { forwardRef, useContext, useImperativeHandle, useRef, useState, useEffect } from 'react';
import {
    UnderwritingFormContext,
    founderIntialState,
    investmentRoundsInitialState,
} from '../context/UnderwritingFormContext';
import arrayMutators from 'final-form-arrays';
import { findFirstErrorField, setFieldTouchedMutator } from '../../../components/functions/utilities';
import MeritoRadioButton from '../../Finance/components/RadioButton/MeritoRadioButton';
import { OnChange } from 'react-final-form-listeners';
import { FieldArray } from 'react-final-form-arrays';
import InvestmentRounds from './InvestmentRounds';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import { RiAddFill as AddIcon } from 'react-icons/ri';
import { alignmentType, UnderwritingSteps } from '../../../interfaces/interfaces';
import dayjs from 'dayjs';
import { getIn } from 'final-form';
import TableInvestments from './TableInvestment/TableInvestment';
import { Modal } from 'reactstrap';
import InvestmentsGrid from './InvestmentsGrid';
import { investmentFormValidation } from './investementHelper';
import { useSearchParams } from 'react-router-dom';

type Props = {
    setFormPristine: (value: boolean) => void,
    saveToLocalStorage?: (values: Record<string, any>) => void,
};

const InvestmentsRevamp = forwardRef(({ setFormPristine, saveToLocalStorage }: Props, ref) => {
    const { formData, formStepsValidity, setStepValidity } = useContext(UnderwritingFormContext);
    const formRef = useRef<any>(null);
    const [isOpenInvestment, setIsOpenInvestment] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const showError = searchParams.get('error');
        if (showError == "true") {
            formRef?.current?.submit();
            scrollToFirstError();
        }
    }, [searchParams])

    useImperativeHandle(
        ref,
        () => ({
            submitForm: () => {
                return new Promise((resolve) => {
                    formRef.current.submit();
                    if (!formStepsValidity[UnderwritingSteps.investments]) {
                        scrollToFirstError();
                        resolve({ success: false, values: formRef?.current?.getState().values, pristine: formRef?.current?.getState().pristine });
                    } else {
                        resolve({
                            success: true,
                            values: formRef?.current?.getState().values,
                            pristine: formRef?.current?.getState().pristine,
                        });
                    }
                });
            },
        }),
        [formStepsValidity]
    );

    const onAddInvestmentScroll = (divId: string) => {
        const element = document.getElementById(divId);
        element?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToFirstError = () => {
        try {
            const formState = formRef.current.getState();
            const { errors } = formState;
            const firstErrorField = findFirstErrorField(errors);
            const errorField = document.querySelector(`[name="${firstErrorField}"]`);
            if (errorField) {
                errorField.scrollIntoView({ behavior: 'smooth' });
            }
        } catch (error) {
            console.log('error', error);
        }
    };





    return (
        <div className={styles.rootContainer}>
            <Form
                initialValues={formData}
                onSubmit={(values) => {
                    return {};
                }}
                mutators={{
                    ...arrayMutators,
                    setFieldTouched: setFieldTouchedMutator,
                }}
                validate={(values) => {
                    const { errors } = investmentFormValidation(values);
                    return errors;
                }}
                render={({ values, handleSubmit, form: { mutators, change, ...restProps } }) => {
                    formRef.current = { mutators, change, ...restProps };
                    return (
                        <form className={styles.formWrapper} onSubmit={handleSubmit}>
                            <FormSpy
                                subscription={{ valid: true, pristine: true, values: true }}
                                onChange={(state) => {
                                    setFormPristine(state.pristine);
                                    setStepValidity(UnderwritingSteps.investments, state.valid);
                                    saveToLocalStorage?.(state.values);
                                }}
                            />
                            <div className={styles.formRootContainer}>
                                <div className={styles.sectionContainer}>
                                    <div className={styles.sectionTitle}>Investments</div>
                                    <div className={styles.sectionFieldsContainer}>
                                        <Field name="raisedInvestment">
                                            {(props) => (
                                                <MeritoRadioButton
                                                    {...props.input}
                                                    label="Has your brand raised external investments?"
                                                    radioLabels={[
                                                        { label: 'Yes', value: 'yes' },
                                                        { label: 'No', value: 'no' },
                                                    ]}
                                                    name={props.input.name}
                                                    value={props.input.value}
                                                    onChange={props.input.onChange}
                                                    error={props.meta.error}
                                                    size="md2"
                                                />
                                            )}
                                        </Field>

                                        {values?.raisedInvestment == 'yes' && (
                                            <div className={styles.fieldsContainer}>
                                                <div className={styles.addDetailsRootContainer}>
                                                    <div className={styles.leftContainer}>
                                                        <div className={styles.title}>
                                                            Investments
                                                        </div>
                                                    </div>
                                                    <div className={styles.rightContainer}>
                                                        <MeritoButton
                                                            btnText="Add Details"
                                                            type='primary-1'
                                                            size='md'
                                                            onClick={() => {
                                                                setIsOpenInvestment(true)
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <Field name="investmentRounds">
                                                    {(props) => (
                                                        <>
                                                            {props?.meta?.error && props?.meta?.touched ? <div className={styles.errorContainer}>
                                                                {props?.meta?.error}
                                                            </div> : null}
                                                        </>
                                                    )}
                                                </Field>
                                                <Modal
                                                    isOpen={isOpenInvestment}
                                                    toggle={() => {
                                                        setIsOpenInvestment(!isOpenInvestment)
                                                    }}
                                                    size='lg'
                                                    fullscreen={true}
                                                    keyboard={false}
                                                >
                                                    <InvestmentsGrid fieldName='investmentRounds' setIsOpen={setIsOpenInvestment} isOpen={isOpenInvestment} />
                                                </Modal>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    );
                }}
            />
        </div>
    );
});

export default InvestmentsRevamp;
